import { InsightDirection, type InsightFilter } from '@api/api/insights';
import type {
  KgInsightMention,
  KgInsightSentiment,
} from '@api/api/kg-insights';

import { PulseSentimentBreakdown } from '../pulse-types';

type ScenarioInsightSentiment = {
  metadata: Pick<InsightFilter['metadata'], 'direction'>;
};

const emptyCounts = () => ({ positive: 0, negative: 0, neutral: 0 });

const scenarioSentimentByDirection: Partial<
  Record<InsightDirection, KgInsightSentiment>
> = {
  [InsightDirection.Bullish]: 'positive',
  [InsightDirection.Bearish]: 'negative',
} as const;

export const buildSentimentBreakdown = (
  mentions: KgInsightMention[],
  scenarioInsights: ScenarioInsightSentiment[] = []
): PulseSentimentBreakdown => {
  const totals = emptyCounts();
  const sentimentEntries = [
    ...mentions,
    ...scenarioInsights.map(insight => ({
      sentiment: scenarioSentimentByDirection[insight.metadata.direction],
    })),
  ];

  for (const mention of sentimentEntries) {
    if (!mention.sentiment) {
      continue;
    }

    totals[mention.sentiment] += 1;
  }

  return { totals };
};
